import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const STALE_TIME = 5 * 60 * 1000;

const PO_BASE = "/api/analytics/xero/purchase-orders";
const INV_BASE = "/api/analytics/xero/invoices";

/** Xero Purchase Orders for the period (matched to Sell Requests). */
export const useXeroPurchaseOrders = (year, month) =>
  useQuery({
    queryKey: ["xero-pos", year, month],
    queryFn: async () => (await axios.get(PO_BASE, { params: { year, month }, metadata: { silent: true } })).data,
    staleTime: STALE_TIME,
    keepPreviousData: true,
  });

/** Xero sales invoices for the period (matched to Orders). */
export const useXeroInvoices = (year, month) =>
  useQuery({
    queryKey: ["xero-invoices", year, month],
    queryFn: async () => (await axios.get(INV_BASE, { params: { year, month }, metadata: { silent: true } })).data,
    staleTime: STALE_TIME,
    keepPreviousData: true,
  });

const base = (kind) => (kind === "po" ? PO_BASE : INV_BASE);

/** Force a live refetch from Xero (busts the server cache). */
export const refreshXero = async (kind, year, month) =>
  (await axios.get(base(kind), { params: { year, month, refresh: 1 } })).data;

/** Stream a doc's PDF (auth header is sent by axios) and open it in a new tab. */
export const openXeroPdf = async (kind, id) => {
  const res = await axios.get(`${base(kind)}/${encodeURIComponent(id)}/pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank", "noopener");
  // best-effort cleanup once the tab has had a chance to load it
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

/** Void a PO (Xero status DELETED) or invoice (VOIDED). DAO-admin only (server-enforced). */
export const voidXeroDoc = async (kind, id) =>
  (await axios.post(`${base(kind)}/${encodeURIComponent(id)}/void`)).data;
